import { render, staticRenderFns } from "./CuadreServicioForm.vue?vue&type=template&id=0b14c52f&scoped=true&"
import script from "./CuadreServicioForm.vue?vue&type=script&lang=ts&"
export * from "./CuadreServicioForm.vue?vue&type=script&lang=ts&"
import style0 from "./CuadreServicioForm.vue?vue&type=style&index=0&id=0b14c52f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b14c52f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b14c52f', component.options)
    } else {
      api.reload('0b14c52f', component.options)
    }
    module.hot.accept("./CuadreServicioForm.vue?vue&type=template&id=0b14c52f&scoped=true&", function () {
      api.rerender('0b14c52f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/OrdenesServicio/CuadreServicioForm.vue"
export default component.exports